export const ROUTES = {
  home: '/',
  clients: '/clients',
  cars: '/cars',
  events: '/events',
  login: '/login',
} as const

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES]
